export default {
  KC_INPUT_ERROR: "KC_INPUT_ERROR",
  SIGNUP_PAGE: "SIGNUP_PAGE",
  SIGNUP_PAGE_FORM: "SIGNUP_PAGE_FORM",
  SIGNUP_PAGE_NAME_INPUT: "SIGNUP_PAGE_NAME_INPUT",
  SIGNUP_PAGE_PHONE_INPUT: "SIGNUP_PAGE_PHONE_INPUT",
  SIGNUP_PAGE_EMAIL_INPUT: "SIGNUP_PAGE_EMAIL_INPUT",
  SIGNUP_PAGE_PASSWORD_INPUT: "SIGNUP_PAGE_PASSWORD_INPUT",
  SIGNUP_PAGE_SUBMIT_BUTTON: "SIGNUP_PAGE_SUBMIT_BUTTON",
  SIGNUP_PAGE_CLICKABLE_LOGIN: "SIGNUP_PAGE_CLICKABLE_LOGIN",
  SIGNUP_PAGE_CLICKABLE_GDPR_CGU: "SIGNUP_PAGE_CLICKABLE_GDPR_CGU",
  SIGNUP_PAGE_CLICKABLE_GDPR_PRIVACY_POLICY:
    "SIGNUP_PAGE_CLICKABLE_GDPR_PRIVACY_POLICY",
  SAAS_INTRODUCTION_PAGE: "SAAS_INTRODUCTION_PAGE",
  SAAS_INTRODUCTION_VIDEO: "SAAS_INTRODUCTION_VIDEO",
  SAAS_INTRODUCTION_SKIP_BUTTON: "SAAS_INTRODUCTION_SKIP_BUTTON",
  SAAS_CTA_PAGE: "SAAS_CTA_PAGE",
  SAAS_CTA_GOOGLE_SELECTED_WRAPPER: "SAAS_CTA_GOOGLE_SELECTED_WRAPPER",
  GOOGLE_SAAS_CHECKBOX_INPUT: "GOOGLE_SAAS_CHECKBOX_INPUT",
  INSTAGRAM_SAAS_CHECKBOX_INPUT: "INSTAGRAM_SAAS_CHECKBOX_INPUT",
  GOOGLE_CTA_AUTOCOMPLETE_INPUT: "GOOGLE_CTA_AUTOCOMPLETE_INPUT",
  INSTAGRAM_CTA_ACCOUNT_LINK_INPUT: "INSTAGRAM_CTA_ACCOUNT_LINK_INPUT",
  INSTAGRAM_CTA_AUTOCOMPLETE_INPUT: "INSTAGRAM_CTA_AUTOCOMPLETE_INPUT",
  GOOGLE_CTA_AUTOCOMPLETE_DISABLED_INPUT:
    "GOOGLE_CTA_AUTOCOMPLETE_DISABLED_INPUT",
  INSTAGRAM_CTA_AUTOCOMPLETE_DISABLED_INPUT:
    "INSTAGRAM_CTA_AUTOCOMPLETE_DISABLED_INPUT",
  SAAS_CONFIGURATION_SAVE_BUTTON: "SAAS_CONFIGURATION_SAVE_BUTTON",
  SAAS_CONFIGURATION_SKIP_BUTTON: "SAAS_CONFIGURATION_SKIP_BUTTON",
  GOOGLE_CTA_AUTOCOMPLETE_SELECT: "-google-places-suggestions-container",
  ROI_CALCULATION_COMPONENT_WRAPPER: "ROI_CALCULATION_COMPONENT_WRAPPER",
  ROI_CALCULATION_COMPONENT_INPUT: "ROI_CALCULATION_COMPONENT_INPUT",
  ROI_ESTIMATION_COMPONENT: "ROI_ESTIMATION_COMPONENT",
  SAAS_CHECKBOX_INPUT: "SAAS_CHECKBOX_INPUT",
  SAAS_CHECKBOX_INPUT_GOOGLE: "SAAS_CHECKBOX_INPUT_GOOGLE",
  SAAS_CHECKBOX_INPUT_INSTAGRAM: "SAAS_CHECKBOX_INPUT_INSTAGRAM",
  SAAS_GIFTS_PAGE: "SAAS_GIFTS_PAGE",
  GIFT_EDITOR_TABLE: "GIFT_EDITOR_TABLE",
  SAAS_GIFTS_PERCENTAGE_OPTION_INPUT: "SAAS_GIFTS_PERCENTAGE_OPTION_INPUT",
  SAAS_GIFTS_QUANTITY_OPTION_INPUT: "SAAS_GIFTS_QUANTITY_OPTION_INPUT",
  SAAS_GAME_CONFIGURATION_PAGE: "SAAS_GAME_CONFIGURATION_PAGE",
  SAAS_SUMMARY_PAGE: "SAAS_SUMMARY_PAGE",
  SAAS_SUMMARY_PAGE_OBJECTIVES_BUTTON: "SAAS_SUMMARY_PAGE_OBJECTIVES_BUTTON",
  SAAS_SUMMARY_PAGE_GIFTS_BUTTON: "SAAS_SUMMARY_PAGE_GIFTS_BUTTON",
  SAAS_SUMMARY_PAGE_ANIMATION_BUTTON: "SAAS_SUMMARY_PAGE_ANIMATION_BUTTON",
  SAAS_SUMMARY_PAGE_TEST_ANIMATION_BUTTON:
    "SAAS_SUMMARY_PAGE_TEST_ANIMATION_BUTTON",
  SAAS_SUMMARY_PAGE_ORDER_FLYERS_BUTTON:
    "SAAS_SUMMARY_PAGE_ORDER_FLYERS_BUTTON",
  SAAS_SUMMARY_PAGE_GENERATE_QRCODE_BUTTON:
    "SAAS_SUMMARY_PAGE_GENERATE_QRCODE_BUTTON",
  SAAS_SUMMARY_PAGE_GENERATE_FLYER_PDF_BUTTON:
    "SAAS_SUMMARY_PAGE_GENERATE_FLYER_PDF_BUTTON",
  SAAS_SUMMARY_PAGE_GENERATE_GAME_URL_BUTTON:
    "SAAS_SUMMARY_PAGE_GENERATE_GAME_URL_BUTTON",
  SAAS_SUMMARY_CONFIRM_PAYMENT_BUTTON: "SAAS_SUMMARY_CONFIRM_PAYMENT_BUTTON",
  SAAS_COLOR_SELECTOR: "SAAS_COLOR_SELECTOR",
  SAAS_COLOR_SELECTOR_PRIMARY: "SAAS_COLOR_SELECTOR_PRIMARY",
  SAAS_COLOR_SELECTOR_SECONDARY: "SAAS_COLOR_SELECTOR_SECONDARY",
  SAAS_COLOR_SELECTOR_TERTIARY: "SAAS_COLOR_SELECTOR_TERTIARY",
  SAAS_SUMMARY_ANIMATION_SHARING_MODAL_DOWNLOAD_BUTTON:
    "SAAS_SUMMARY_ANIMATION_SHARING_MODAL_DOWNLOAD_BUTTON",
  SAAS_SUMMARY_ANIMATION_SHARING_MODAL_EMAIL_BUTTON:
    "SAAS_SUMMARY_ANIMATION_SHARING_MODAL_EMAIL_BUTTON",
  SAAS_GAME_CONFIGURATION_PLV_LOGO: "SAAS_GAME_CONFIGURATION_PLV_LOGO",
  SAAS_SUMMARY_PAGE_COMPLETED_SECTION: "SAAS_SUMMARY_PAGE_COMPLETED_SECTION",
  SAAS_SUMMARY_PAGE_COMPLETED_SECTION_ANIMATION_BUTTON:
    "SAAS_SUMMARY_PAGE_COMPLETED_SECTION_ANIMATION_BUTTON",
  SAAS_SUMMARY_PAGE_TEST_ANIMATION_MODAL:
    "SAAS_SUMMARY_PAGE_TEST_ANIMATION_MODAL",
  SAAS_SUMMARY_PAGE_GENERATE_QRCODE_MODAL:
    "SAAS_SUMMARY_PAGE_GENERATE_QRCODE_MODAL",
  SAAS_SUMMARY_PAGE_GENERATE_FLYER_PDF_MODAL:
    "SAAS_SUMMARY_PAGE_GENERATE_FLYER_PDF_MODAL",
  SAAS_SUMMARY_PAGE_GENERATE_GAME_URL_MODAL:
    "SAAS_SUMMARY_PAGE_GENERATE_GAME_URL_MODAL",
  SAAS_FLYERS_ORDER_PAGE_CONTAINER: "SAAS_FLYERS_ORDER_PAGE_CONTAINER",
  SAAS_FLYERS_ORDER_PAGE_QUANTITY_CONTAINER:
    "SAAS_FLYERS_ORDER_PAGE_QUANTITY_CONTAINER",
  SAAS_FLYERS_ORDER_PAGE_DELIVERY_CONTAINER:
    "SAAS_FLYERS_ORDER_PAGE_DELIVERY_CONTAINER",
  SAAS_FLYERS_ORDER_PAGE_PAYMENT_CONTAINER:
    "SAAS_FLYERS_ORDER_PAGE_PAYMENT_CONTAINER",
  SAAS_FLYERS_ORDER_PREV_BUTTON: "SAAS_FLYERS_ORDER_PREV_BUTTON",
  SAAS_FLYERS_ORDER_NEXT_BUTTON: "SAAS_FLYERS_ORDER_NEXT_BUTTON",
  SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT:
    "SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT",
  SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT_WRAPPER:
    "SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT_WRAPPER",
  SAAS_FLYERS_ORDER_PAGE_QUANTITY_EASEL_INPUT:
    "SAAS_FLYERS_ORDER_PAGE_QUANTITY_EASEL_INPUT",
  SAAS_FLYERS_ORDER_PAGE_DELIVERY_NAME_INPUT:
    "SAAS_FLYERS_ORDER_PAGE_DELIVERY_NAME_INPUT",
  SAAS_FLYERS_ORDER_PAGE_DELIVERY_PHONE_INPUT:
    "SAAS_FLYERS_ORDER_PAGE_DELIVERY_PHONE_INPUT",
  SAAS_END_TRIAL_PERIOD_MODAL: "SAAS_END_TRIAL_PERIOD_MODAL",
  ADDRESS_EDITOR_DELIVERY_ADDRESS_INPUT:
    "ADDRESS_EDITOR_DELIVERY_ADDRESS_INPUT",
  ADDRESS_EDITOR_DELIVERY_NAME_INPUT: "ADDRESS_EDITOR_DELIVERY_NAME_INPUT",
  checkoutButton: "checkoutButton",
  SAAS_END_TRIAL_PERIOD_GO_TO_PAYMENT_BUTTON:
    "SAAS_END_TRIAL_PERIOD_GO_TO_PAYMENT_BUTTON",
  SAAS_END_TRIAL_PERIOD_PAYMENT_FORM: "SAAS_END_TRIAL_PERIOD_PAYMENT_FORM",
  BILLS_TABLE: "BILLS_TABLE",
  LOGIN_PAGE: "LOGIN_PAGE",
  LOGIN_PAGE_EMAIL_INPUT: "LOGIN_PAGE_EMAIL_INPUT",
  LOGIN_PAGE_PASSWORD_INPUT: "LOGIN_PAGE_PASSWORD_INPUT",
  LOGIN_PAGE_ACTION_LOGIN: "LOGIN_PAGE_ACTION_LOGIN",
  SUPPORTS_PAGE: "SUPPORTS_PAGE",
  POS_DISPLAY_ORDER_BUTTON: "POS_DISPLAY_ORDER_BUTTON",
  SAAS_FLYERS_ADD_CARD_BUTTON: "SAAS_FLYERS_ADD_CARD_BUTTON",
  ERROR_POPUP: "ERROR_POPUP",

  POSA_TABLE: "POSA_TABLE",

  LOGOUT_BUTTON: "LOGOUT_BUTTON",

  ONBOARDING_STEP_ROW: "ONBOARDING_STEP_ROW",

  JP_FORM_SUBMIT_BTN: "jp-config-form-submit"
};
